var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parent" }, [
    _c("div", { staticClass: "scroll" }, [
      _c("table", { staticClass: "hidetabledynamic" }, [
        _c("tr", [
          _c("td", { staticClass: "hidetabledynamic" }, [
            _c(
              "table",
              {
                staticClass: "hidetable",
                staticStyle: {
                  "table-layout": "fixed",
                  display: "table",
                  float: "left"
                }
              },
              [
                _c("tr", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "hidetable",
                      staticStyle: { "table-layout": "fixed", width: "500px" },
                      attrs: { colspan: "3" }
                    },
                    [
                      _c("autocomplete", {
                        staticStyle: { width: "100%" },
                        attrs: { id: "employeeSearch", type: 28 },
                        on: { finish: _vm.setData },
                        model: {
                          value: _vm.employeeSearch,
                          callback: function($$v) {
                            _vm.employeeSearch = $$v
                          },
                          expression: "employeeSearch"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "hidetable",
                      staticStyle: { width: "50px" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticStyle: { height: "30px", width: "40px" },
                          on: {
                            click: function($event) {
                              return _vm.addEmployee()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "user-plus" }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "hidetable",
                      staticStyle: { width: "50px" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticStyle: { height: "30px", width: "40px" },
                          on: {
                            click: function($event) {
                              return _vm.addAllEmployees()
                            }
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "users" } })],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "hidetable", attrs: { colspan: "2" } },
                    _vm._l(_vm.employeeNames, function(employeeName, i) {
                      return _c("div", { key: JSON.stringify(employeeName) }, [
                        _c(
                          "button",
                          {
                            staticClass: "employeebox",
                            attrs: { id: "employee" + i },
                            on: {
                              click: function($event) {
                                return _vm.removeEmployee(i)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(employeeName) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("td", { staticClass: "hidetable" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.startDate,
                          expression: "startDate"
                        }
                      ],
                      staticClass: "date",
                      staticStyle: { height: "25px", width: "100%" },
                      attrs: { id: "startDate", type: "date" },
                      domProps: { value: _vm.startDate },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.startDate = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("td", { staticClass: "hidetable" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.endDate,
                          expression: "endDate"
                        }
                      ],
                      staticClass: "date",
                      staticStyle: { height: "25px", width: "100%" },
                      attrs: { id: "endDate", type: "date" },
                      domProps: { value: _vm.endDate },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.endDate = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "hidetable" }, [
                    _c(
                      "button",
                      {
                        staticStyle: { height: "30px", width: "40px" },
                        on: {
                          click: function($event) {
                            return _vm.newDates(true)
                          }
                        }
                      },
                      [_c("font-awesome-icon", { attrs: { icon: "check" } })],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "hidetable" }, [
                    _c(
                      "button",
                      {
                        staticStyle: { height: "30px", width: "40px" },
                        on: {
                          click: function($event) {
                            return _vm.toggleShowEmpty()
                          }
                        }
                      },
                      [
                        _vm.showEmpty == true
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "toggle-on" }
                            })
                          : _c("font-awesome-icon", {
                              attrs: { icon: "toggle-off" }
                            })
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ]),
          _c("td", { staticClass: "hidetabledynamic" }, [
            _c("div", [
              _c(
                "table",
                { staticStyle: { "font-size": "12px" } },
                [
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            padding: "3px",
                            height: "0px",
                            "font-weight": "bold"
                          }
                        },
                        [_vm._v("Legend")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.colorList.length / 3, function(i) {
                        return _c(
                          "td",
                          { staticStyle: { padding: "3px", height: "0px" } },
                          [
                            _vm._v(
                              _vm._s(_vm.colorList[(i - 1) * 3][0].substr(0, 5))
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(3, function(i) {
                    return _c(
                      "tr",
                      [
                        i == 1
                          ? _c(
                              "td",
                              {
                                staticStyle: { padding: "3px", height: "0px" }
                              },
                              [_vm._v("Completed")]
                            )
                          : i == 2
                          ? _c(
                              "td",
                              {
                                staticStyle: { padding: "3px", height: "0px" }
                              },
                              [_vm._v("Open")]
                            )
                          : i == 3
                          ? _c(
                              "td",
                              {
                                staticStyle: { padding: "3px", height: "0px" }
                              },
                              [_vm._v("Cancelled")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.colorList.length / 3, function(j) {
                          return _c(
                            "td",
                            { staticStyle: { padding: "3px", height: "0px" } },
                            [
                              _c("div", {
                                style: {
                                  width: "20px",
                                  height: "20px",
                                  background:
                                    "#" +
                                    _vm.colorList[(j - 1) * 3 + (i - 1)][2],
                                  border: "1px solid #000000"
                                }
                              })
                            ]
                          )
                        })
                      ],
                      2
                    )
                  })
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.overview == false
        ? _c(
            "div",
            { ref: "timechart" },
            _vm._l(_vm.employeeIds, function(employeeId, i) {
              return _c(
                "div",
                { key: JSON.stringify(employeeId) },
                _vm._l(_vm.dates, function(date, j) {
                  return _c(
                    "div",
                    [
                      _c("timetable", {
                        staticStyle: { width: "100%", height: "auto" },
                        attrs: {
                          id: _vm.id,
                          timeTableID: j + i * _vm.dates.length,
                          employeeID: employeeId,
                          employeeName: _vm.employeeNames[i],
                          showEmpty: _vm.showEmpty,
                          searchDate: date
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            }),
            0
          )
        : _c(
            "div",
            { ref: "timechart" },
            _vm._l(_vm.dates, function(date, j) {
              return _c(
                "div",
                [
                  _c("timetable-overview", {
                    staticStyle: { width: "100%", height: "auto" },
                    attrs: {
                      id: _vm.id,
                      timeTableID: j,
                      employeeIDS: _vm.employeeIds,
                      showEmpty: _vm.showEmpty,
                      searchDate: date
                    }
                  })
                ],
                1
              )
            }),
            0
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticClass: "hidetable", staticStyle: { width: "100px" } },
      [_c("div", { staticStyle: { float: "right" } }, [_vm._v("Employees")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "hidetable" }, [
      _c("div", { staticStyle: { float: "right" } }, [_vm._v("From")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "hidetable" }, [
      _c("div", { staticStyle: { float: "right" } }, [_vm._v("To")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0171b04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0171b04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout_4.vue
// module id = 750
// module chunks = 0